import { render, staticRenderFns } from "./SubNav.vue?vue&type=template&id=af87a25a&scoped=true"
import script from "./SubNav.vue?vue&type=script&lang=js"
export * from "./SubNav.vue?vue&type=script&lang=js"
import style0 from "./SubNav.vue?vue&type=style&index=0&id=af87a25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af87a25a",
  null
  
)

export default component.exports